module.exports = __webpack_public_path__ + "static/media/github-logomark-white.66b2580c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/github-logomark-white.svg
// module id = 949
// module chunks = 0